import CryptoJS from 'crypto-js'

import { GetSessionData, UpdateSessionData } from './../BL/Sessions'


// //--- API ---//
// /**
//  * Función que obtiene la información del juego que eligió el usuario
//  * @returns 
//  */
// const GetDinyamics = async () => {
//     try {
//         const response = await fetch(process.env.REACT_APP_API_URL + "Dynamics/getDynamics", {
//             method: 'GET',
//             headers: {
//                 'Content-Type': 'application/json',
//             }
//         })
        
//         if (!response.ok) {
//             // Manejar errores HTTP
//             const errorData = await response.json()
//             return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
//         }
        
//         const data = await response.json()
        
//         // Retornar la respuesta exitosa
//         return { success: true, data }
//     } catch (error) {
//         return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
//     }
// }
// //--- API ---//




/**
 * Función que obtiene la información del juego que eligió el usuario
 * @returns 
 */
const GetGame = async () => {
    try {
        const response = await GetSessionData()

        if (response.success) {
            const game = response?.data?.navigation?.game

            if (game) {
                return { success: true, data: game }
            } else {
                return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
            }
        } else {
            return { success: false, message: response.message }
        }  
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

/**
 * Función que guarda el juego que eligió el usuario
 * @param {object} gameData
 * @returns 
 */
const SaveGame = async (gameData) => {
    try {
        const idGame = gameData?.id

        if (!idGame) {
            return { success: false, message: 'Lo sentimos. El juego que elegiste no es válido. Selecciona uno válido.' }
        }

        if (isNaN(idGame)) {
            return { success: false, message: 'Lo sentimos. El juego que elegiste no es válido. Selecciona uno válido.' }
        }

        if (!Number.isInteger(gameData.id) || gameData.id < 1 || gameData.id > 3) {
            return { success: false, message: 'Lo sentimos. El juego que elegiste no es válido. Selecciona uno válido.' }
        }

        switch (gameData.id) {
            case 1:
                gameData.name = 'Trivia'
                break

            case 2:
                gameData.name = 'Lotería'
                break
        
            case 3:
                gameData.name = 'Pelota'
                break
        }
        
        if (!gameData.name) {
            return { success: false, message: 'Lo sentimos. Hubo un error al intentar avanzar al juego. Inténtalo nuevamente o inténtalo más tarde.' }
        } else {
            const response = await GetSessionData()
        
            if (response.success === false) {
                return { success: false, message: 'Lo sentimos. Hubo un error al intentar avanzar al juego. Inténtalo nuevamente o inténtalo más tarde.' }
            }

            response.data.navigation = {
                ...response.data.navigation,
                game: {
                    id: gameData.id,
                    name: gameData.name
                }
            }

            const responseSaveData = await UpdateSessionData(response.data)

            if (responseSaveData.success) {
                return { success: true, data: null }            
            } else {
                return { success: false, message: 'Lo sentimos. Hubo un error al intentar avanzar al juego. Inténtalo nuevamente o inténtalo más tarde.' }
            }
        }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar guardar la información. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

/**
 * Función que elimina la información del juego que eligió el usuario
 * @returns 
 */
const DeleteGame = async () => {
    try {
        const response = await GetSessionData()
        
        if (response.success) {
            let newData = null

            const game = response?.data?.navigation?.game

            if (game) {
                response.data.navigation.game = null

                const responseSaveData = await UpdateSessionData(response.data)

                if (responseSaveData.success) {
                    newData = responseSaveData.data
                    return { success: true, data: null }
                } else {
                    newData = response.data
                    return { success: false, message: 'Lo sentimos. Hubo un error al intentar avanzar al juego. Inténtalo nuevamente o inténtalo más tarde.' }
                }
            } else {
                newData = response.data
            }

            return { success: true, data: newData }
        } else {
            return { success: false, message: response.message }
        }  
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}


//----- LOTTERY ------//

const GetDecryptedLotteryCookie = (cookieName, secretKey) => {
    try {
        const cookies = document.cookie.split(';')
        const rawCookie = cookies.find(c => c.trim().startsWith(`${cookieName}=`))
        
        if (!rawCookie) return null
        
        const encryptedValue = decodeURIComponent(rawCookie.split('=')[1])
        const bytes = CryptoJS.AES.decrypt(encryptedValue, secretKey)
        const decrypted = bytes.toString(CryptoJS.enc.Utf8)

        return JSON.parse(decrypted)
    } catch (error) {
        console.error('Error al leer o desencriptar la cookie:', error)
        return null
    }
}

const SetEncryptedLotteryCookie = (cookieName, data, secretKey, expiresInDays = 1) => {
    try {
        const jsonData = JSON.stringify(data)
        const encrypted = CryptoJS.AES.encrypt(jsonData, secretKey).toString()

        const expires = new Date()
        expires.setTime(expires.getTime() + (expiresInDays * 24 * 60 * 60 * 1000))
        
        document.cookie = `${cookieName}=${encodeURIComponent(encrypted)}; expires=${expires.toUTCString()}; path=/; secure; samesite=strict`
    } catch (error) {
        console.error('Error al guardar la cookie cifrada:', error)
    }
}

/**
 * Función que obtiene la información guardada de la lotería en las cookies
 * @returns 
 */
const GetLotteryData = async (payload) => {
    try {
        console.log('payload: ' + JSON.stringify(payload))
        
        //const secret = process.env.REACT_APP_COOKIE
        const lotteryData = await GetDecryptedLotteryCookie(process.env.REACT_APP_COOKIE_NAME, process.env.REACT_APP_COOKIE)
        
        if (!lotteryData) {
            return { success: false, message: '' }
        }
        
        console.log('lotteryData: ' + lotteryData)

        const idGame = payload?.id
        if (idGame === lotteryData.id) {
            // Si es el mismo juego, devuelvo esto.
            return { success: true, data: lotteryData }
        } else {
            // Si no, regreso false para que vaya por lo nuevo
            return { success: false }
        }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

/**
 * Función que guarda la información de la lotería en las cookies
 * @returns 
 */
const SaveLotteryData = async (lotteryData) => {
    try {
        console.log('lotteryData: ' + lotteryData)
        
        //const secret = process.env.REACT_APP_COOKIE
        await SetEncryptedLotteryCookie(process.env.REACT_APP_COOKIE_NAME, lotteryData, process.env.REACT_APP_COOKIE, 1)
        
        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

//----- LOTTERY ------//

export { GetGame, SaveGame, DeleteGame, GetLotteryData, SaveLotteryData };